/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 10:37:45
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {CompareExceptionDOI} from "./api/compareExceptionApi";
import CompareExceptionService from "./service/compareExceptionService";
import './compareException.less';

@Component({name: 'compare-exception'})
export default class CompareException extends BasicSearchPage<CompareExceptionService, CompareExceptionDOI.RowDataI, CompareExceptionDOI.QueryRowDataParamsI> {
    checkBoxShow = true
    
    @override
    renderHead(h) {
        return <div></div>
    }
	@override
	loadService () {
		this.service = new CompareExceptionService(this)
	}
}